var _filter, _rect, _rect2, _text, _g, _g2, _g3, _g4, _g5, _g6;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSvgExpressVsFastify(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 700 400",
    fontFamily: "'Segoe UI', Arial, sans-serif",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "bg5",
    x1: "0%",
    y1: "0%",
    x2: "100%",
    y2: "100%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    style: {
      stopColor: "#0f0f1a"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    style: {
      stopColor: "#1a1a2e"
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "expressGrad",
    x1: "0%",
    y1: "0%",
    x2: "100%",
    y2: "0%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    style: {
      stopColor: "#6b7280"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    style: {
      stopColor: "#4b5563"
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "fastifyGrad",
    x1: "0%",
    y1: "0%",
    x2: "100%",
    y2: "0%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    style: {
      stopColor: "#6c63ff"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    style: {
      stopColor: "#a855f7"
    }
  })), _filter || (_filter = /*#__PURE__*/React.createElement("filter", {
    id: "glow5"
  }, /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "coloredBlur"
  }), /*#__PURE__*/React.createElement("feMerge", null, /*#__PURE__*/React.createElement("feMergeNode", {
    in: "coloredBlur"
  }), /*#__PURE__*/React.createElement("feMergeNode", {
    in: "SourceGraphic"
  }))))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 700,
    height: 400,
    rx: 16,
    fill: "url(#bg5)"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 700,
    height: 400,
    rx: 16,
    fill: "none",
    stroke: "#6c63ff",
    strokeWidth: 1,
    opacity: 0.2
  })), _text || (_text = /*#__PURE__*/React.createElement("text", {
    x: 350,
    y: 38,
    textAnchor: "middle",
    fill: "#c4b5fd",
    fontSize: 20,
    fontWeight: 700,
    opacity: 0
  }, "\n    Express vs Fastify\n    ", /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    from: 0,
    to: 1,
    dur: "0.6s",
    fill: "freeze"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    from: 0,
    to: 1,
    dur: "0.5s",
    begin: "0.3s",
    fill: "freeze"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 35,
    y: 55,
    width: 170,
    height: 38,
    rx: 8,
    fill: "#1e293b"
  }), /*#__PURE__*/React.createElement("text", {
    x: 120,
    y: 79,
    textAnchor: "middle",
    fill: "#94a3b8",
    fontSize: 13,
    fontWeight: 700
  }, "Feature"), /*#__PURE__*/React.createElement("rect", {
    x: 220,
    y: 55,
    width: 210,
    height: 38,
    rx: 8,
    fill: "url(#expressGrad)"
  }), /*#__PURE__*/React.createElement("text", {
    x: 325,
    y: 79,
    textAnchor: "middle",
    fill: "#fff",
    fontSize: 13,
    fontWeight: 700
  }, "\u26A1 Express"), /*#__PURE__*/React.createElement("rect", {
    x: 445,
    y: 55,
    width: 220,
    height: 38,
    rx: 8,
    fill: "url(#fastifyGrad)",
    filter: "url(#glow5)"
  }), /*#__PURE__*/React.createElement("text", {
    x: 555,
    y: 79,
    textAnchor: "middle",
    fill: "#fff",
    fontSize: 13,
    fontWeight: 700
  }, "\uD83D\uDE80 Fastify"))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    opacity: 0
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    from: 0,
    to: 1,
    dur: "0.5s",
    begin: "0.6s",
    fill: "freeze"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 35,
    y: 102,
    width: 170,
    height: 55,
    rx: 6,
    fill: "#12121f",
    stroke: "#334155",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("text", {
    x: 120,
    y: 125,
    textAnchor: "middle",
    fill: "#e2e8f0",
    fontSize: 12,
    fontWeight: 600
  }, "JSON"), /*#__PURE__*/React.createElement("text", {
    x: 120,
    y: 143,
    textAnchor: "middle",
    fill: "#94a3b8",
    fontSize: 10
  }, "Serialization"), /*#__PURE__*/React.createElement("rect", {
    x: 220,
    y: 102,
    width: 210,
    height: 55,
    rx: 6,
    fill: "#12121f",
    stroke: "#334155",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 240,
    y: 118,
    width: 90,
    height: 20,
    rx: 10,
    fill: "#f59e0b",
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("text", {
    x: 285,
    y: 133,
    textAnchor: "middle",
    fill: "#fbbf24",
    fontSize: 12,
    fontWeight: 600
  }, "Moderate"), /*#__PURE__*/React.createElement("text", {
    x: 355,
    y: 133,
    fill: "#6b7280",
    fontSize: 18
  }, "\u26A0\uFE0F"), /*#__PURE__*/React.createElement("rect", {
    x: 445,
    y: 102,
    width: 220,
    height: 55,
    rx: 6,
    fill: "#12121f",
    stroke: "#6c63ff",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 465,
    y: 118,
    width: 130,
    height: 20,
    rx: 10,
    fill: "#22c55e",
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("text", {
    x: 530,
    y: 133,
    textAnchor: "middle",
    fill: "#4ade80",
    fontSize: 12,
    fontWeight: 600
  }, "Highly Optimized"), /*#__PURE__*/React.createElement("text", {
    x: 610,
    y: 133,
    fill: "#22c55e",
    fontSize: 18
  }, "\u2705"))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    opacity: 0
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    from: 0,
    to: 1,
    dur: "0.5s",
    begin: "0.9s",
    fill: "freeze"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 35,
    y: 166,
    width: 170,
    height: 55,
    rx: 6,
    fill: "#12121f",
    stroke: "#334155",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("text", {
    x: 120,
    y: 189,
    textAnchor: "middle",
    fill: "#e2e8f0",
    fontSize: 12,
    fontWeight: 600
  }, "Schema"), /*#__PURE__*/React.createElement("text", {
    x: 120,
    y: 207,
    textAnchor: "middle",
    fill: "#94a3b8",
    fontSize: 10
  }, "Validation"), /*#__PURE__*/React.createElement("rect", {
    x: 220,
    y: 166,
    width: 210,
    height: 55,
    rx: 6,
    fill: "#12121f",
    stroke: "#334155",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 240,
    y: 182,
    width: 70,
    height: 20,
    rx: 10,
    fill: "#ef4444",
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("text", {
    x: 275,
    y: 197,
    textAnchor: "middle",
    fill: "#fca5a5",
    fontSize: 12,
    fontWeight: 600
  }, "Manual"), /*#__PURE__*/React.createElement("text", {
    x: 355,
    y: 197,
    fill: "#6b7280",
    fontSize: 18
  }, "\u274C"), /*#__PURE__*/React.createElement("rect", {
    x: 445,
    y: 166,
    width: 220,
    height: 55,
    rx: 6,
    fill: "#12121f",
    stroke: "#6c63ff",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 465,
    y: 182,
    width: 120,
    height: 20,
    rx: 10,
    fill: "#22c55e",
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("text", {
    x: 525,
    y: 197,
    textAnchor: "middle",
    fill: "#4ade80",
    fontSize: 12,
    fontWeight: 600
  }, "Built-in (Fast)"), /*#__PURE__*/React.createElement("text", {
    x: 610,
    y: 197,
    fill: "#22c55e",
    fontSize: 18
  }, "\u2705"))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    opacity: 0
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    from: 0,
    to: 1,
    dur: "0.5s",
    begin: "1.2s",
    fill: "freeze"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 35,
    y: 230,
    width: 170,
    height: 55,
    rx: 6,
    fill: "#12121f",
    stroke: "#334155",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("text", {
    x: 120,
    y: 255,
    textAnchor: "middle",
    fill: "#e2e8f0",
    fontSize: 12,
    fontWeight: 600
  }, "Overhead"), /*#__PURE__*/React.createElement("text", {
    x: 120,
    y: 273,
    textAnchor: "middle",
    fill: "#94a3b8",
    fontSize: 10
  }, "Per Request"), /*#__PURE__*/React.createElement("rect", {
    x: 220,
    y: 230,
    width: 210,
    height: 55,
    rx: 6,
    fill: "#12121f",
    stroke: "#334155",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 240,
    y: 246,
    width: 70,
    height: 20,
    rx: 10,
    fill: "#ef4444",
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("text", {
    x: 275,
    y: 261,
    textAnchor: "middle",
    fill: "#fca5a5",
    fontSize: 12,
    fontWeight: 600
  }, "Higher"), /*#__PURE__*/React.createElement("text", {
    x: 355,
    y: 261,
    fill: "#ef4444",
    fontSize: 18
  }, "\uD83D\uDCC8"), /*#__PURE__*/React.createElement("rect", {
    x: 445,
    y: 230,
    width: 220,
    height: 55,
    rx: 6,
    fill: "#12121f",
    stroke: "#6c63ff",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 465,
    y: 246,
    width: 80,
    height: 20,
    rx: 10,
    fill: "#22c55e",
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("text", {
    x: 505,
    y: 261,
    textAnchor: "middle",
    fill: "#4ade80",
    fontSize: 12,
    fontWeight: 600
  }, "Minimal"), /*#__PURE__*/React.createElement("text", {
    x: 610,
    y: 261,
    fill: "#22c55e",
    fontSize: 18
  }, "\uD83C\uDFCE\uFE0F"))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    opacity: 0
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    from: 0,
    to: 1,
    dur: "0.5s",
    begin: "1.5s",
    fill: "freeze"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 35,
    y: 294,
    width: 170,
    height: 55,
    rx: 6,
    fill: "#12121f",
    stroke: "#334155",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("text", {
    x: 120,
    y: 317,
    textAnchor: "middle",
    fill: "#e2e8f0",
    fontSize: 12,
    fontWeight: 600
  }, "Plugin"), /*#__PURE__*/React.createElement("text", {
    x: 120,
    y: 335,
    textAnchor: "middle",
    fill: "#94a3b8",
    fontSize: 10
  }, "System"), /*#__PURE__*/React.createElement("rect", {
    x: 220,
    y: 294,
    width: 210,
    height: 55,
    rx: 6,
    fill: "#12121f",
    stroke: "#334155",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 240,
    y: 310,
    width: 130,
    height: 20,
    rx: 10,
    fill: "#f59e0b",
    opacity: 0.15
  }), /*#__PURE__*/React.createElement("text", {
    x: 305,
    y: 325,
    textAnchor: "middle",
    fill: "#fbbf24",
    fontSize: 12,
    fontWeight: 600
  }, "Middleware-based"), /*#__PURE__*/React.createElement("rect", {
    x: 445,
    y: 294,
    width: 220,
    height: 55,
    rx: 6,
    fill: "#12121f",
    stroke: "#6c63ff",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 465,
    y: 310,
    width: 150,
    height: 20,
    rx: 10,
    fill: "#22c55e",
    opacity: 0.15
  }), /*#__PURE__*/React.createElement("text", {
    x: 540,
    y: 325,
    textAnchor: "middle",
    fill: "#4ade80",
    fontSize: 12,
    fontWeight: 600
  }, "Hooks &amp; Decorators"))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    opacity: 0
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    from: 0,
    to: 1,
    dur: "0.6s",
    begin: "1.8s",
    fill: "freeze"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 35,
    y: 362,
    width: 630,
    height: 28,
    rx: 8,
    fill: "#0f0a1f",
    stroke: "#a855f7",
    strokeWidth: 1,
    opacity: 0.7
  }), /*#__PURE__*/React.createElement("text", {
    x: 350,
    y: 381,
    textAnchor: "middle",
    fill: "#c4b5fd",
    fontSize: 12,
    fontWeight: 600
  }, "\n      \uD83C\uDFC6 Fastify is designed for raw speed \u2014 ~65% faster than Express under the same conditions\n    "), /*#__PURE__*/React.createElement("rect", {
    x: 445,
    y: 55,
    width: 5,
    height: 294,
    rx: 2,
    fill: "#fff",
    opacity: 0
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "x",
    from: 445,
    to: 665,
    dur: "2s",
    begin: "2s",
    repeatCount: "indefinite"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    values: "0;0.15;0",
    dur: "2s",
    begin: "2s",
    repeatCount: "indefinite"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSvgExpressVsFastify);
export default __webpack_public_path__ + "static/media/svg-express-vs-fastify.8b333c9a41c215c55e82776387d6e47c.svg";
export { ForwardRef as ReactComponent };